import { useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useAuth } from '@unbooking/ui-auth';
import { useWafflesContext } from '../providers/WaffleProvider';
import { buildAuthenticatedRoutes, buildPublicRoutes } from './routes';

export function RoadSafetyRouter() {
  const { isAuthenticated, isLoginInProgress } = useAuth();
  const { flags } = useWafflesContext();

  const router = useMemo(
    () =>
      createBrowserRouter(
        isAuthenticated ? buildAuthenticatedRoutes(flags) : buildPublicRoutes(!!isLoginInProgress),
        { future: { v7_relativeSplatPath: true } },
      ),
    [isAuthenticated, isLoginInProgress, flags],
  );

  return <RouterProvider router={router} />;
}

export default RoadSafetyRouter;
